import axios from "axios";
import {
  PREFERRED_DESTINATION_LIST_REQUEST,
  PREFERRED_DESTINATION_LIST_SUCCESS,
  PREFERRED_DESTINATION_LIST_FAIL,
} from "../constants/countryConstants";
import { api2 } from "../core/api";

export const getCountries = () => async (dispatch) => {
  try {
    dispatch({
      type: PREFERRED_DESTINATION_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.get("/country", config);

    var dt = data.Result;

    if (typeof dt === "string") {
      dispatch({
        type: PREFERRED_DESTINATION_LIST_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: PREFERRED_DESTINATION_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: PREFERRED_DESTINATION_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
